const isValidEmail = (email) => {
	if (!email || typeof email !== 'string' || email.length > 254) {
		return false;
	}
	const re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

	return re.test(String(email).toLowerCase());
};

export {
	isValidEmail
};
